import RecentActivitiesList from './RecentActivitiesList';
import Beneficiaries from './Beneficiaries';
import SelectBank from './SelectBank';

export { RecentActivitiesList, Beneficiaries, SelectBank };
